import React from "react";
import PropTypes from "prop-types";
import i18n from "../../../i18n";
import * as rk from "../../../localization/resourceKeys";
import RighttoCorrectForm from "../../../media/RighttoCorrectForm.pdf";
import RighttoCorrectFormQCPPEN from "../../../media/RightToCorrectForm_QCPP_EN.pdf";
import RighttoCorrectFormQCPPFR from "../../../media/RightToCorrectForm_QCPP_FR.pdf";
import "../updateInfoInMy.css";
import "../rightToCorrect.css";

const VCIConsumer = (props) => {
  const { isWithdraw, isCanada, language } = props;

  let formLink;

  if (isCanada) {
    if (language === 'FRA') {
      formLink = RighttoCorrectFormQCPPFR;
    } else {
      formLink = RighttoCorrectFormQCPPEN;
    }
  } else {
    formLink = RighttoCorrectForm;
  }
  return (
    <div className="u-m-none right-to-correct-wrapper">
      <div className="welcome-note">
        {isWithdraw?  i18n.t(rk.WITHDRAW.TITLE) : i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER)}
      </div>
      <div className="instructions-block o-layout u-1/1 u-m-none">
        <div className="instructions-cta o-layout__item u-1/3 u-1/1@s u-p-none u-pr u-text-center@s">
          <a
            className="a-link-cta"
            href={
              isCanada?
                "https://www.audifinance.ca/login" :
                "https://www.audiusa.com/myaudi"
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="c-btn  c-btn--secondary  c-btn--icon block-cta">
              <span className="c-btn__text u-font-size-fs0" id="go-to-my-audy-btn">
                {i18n.t(rk.DATA_CORRECTION.VCI.CUSTOMER_CTA_1)}
              </span>
              <div className="box-outside-arrow-up-right" />
            </button>
          </a>
        </div>
        <div className="instructions-list o-layout__item u-2/3 u-1/1@s u-p-none@s">
          <p className="intructions-title u-mb-xxsmall u-font-size-fs0">
            {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_BULLET_AUDI)}
          </p>
          <ul className="o-list-casual">
            <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
              {i18n.t(rk.DATA_CORRECTION.VCI.AFS_CURRENT_CUSTOMER_BULLET_1)}
            </li>
            {!isCanada && <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
              {i18n.t(rk.DATA_CORRECTION.VCI.AFS_CURRENT_CUSTOMER_BULLET_2)}
            </li>}
            {isCanada && <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
              {i18n.t(rk.DATA_CORRECTION.VCI.AFS_CURRENT_CUSTOMER_BULLET_2_CANADA_1)}
              <a
                className="a-link-cta-bullet"
                href={i18n.t(rk.DATA_CORRECTION.VCI.AFS_CURRENT_CUSTOMER_BULLET_2_CANADA_AFLINK)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n.t(rk.DATA_CORRECTION.VCI.AFS_CURRENT_CUSTOMER_BULLET_2_CANADA_AF)}
              </a>
              {i18n.t(rk.DATA_CORRECTION.VCI.AFS_CURRENT_CUSTOMER_BULLET_2_CANADA_2)}
            </li>}
            <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
              {i18n.t(rk.DATA_CORRECTION.VCI.AFS_CURRENT_CUSTOMER_BULLET_3)}
            </li>
            <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
              {i18n.t(rk.DATA_CORRECTION.VCI.AFS_CURRENT_CUSTOMER_BULLET_4)}
            </li>
            {isCanada && <div>
              <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
                {i18n.t(rk.DATA_CORRECTION.VCI.AFS_CURRENT_CUSTOMER_BULLET_5)}
              </li> 
            </div>}
          </ul>
        </div>
        <div className="block-divider">
          <hr className="block-horizontal-rule u-mb-none" />
        </div>
        <div className="instructions-cta o-layout__item u-1/3 u-1/1@s u-p-none u-pr u-text-center@s">
          <a
            className="a-link-cta"
            href={
              isCanada?
                "https://www.vwfinance.ca/login/" :
                "https://www.vwcredit.com/login"
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="c-btn  c-btn--secondary  c-btn--icon block-cta">
              <span className="c-btn__text u-font-size-fs0">
                {i18n.t(rk.DATA_CORRECTION.VCI.CUSTOMER_CTA_2)}
              </span>
              <div className="box-outside-arrow-up-right" />
            </button>
          </a>
        </div>
        <div className="instructions-list o-layout__item u-2/3 u-1/1@s u-p-none@s">
          <p className="intructions-title u-mb-xxsmall u-font-size-fs0">
            {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_BULLET_VW)}
          </p>
          <ul className="o-list-casual">
            <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
              {i18n.t(rk.DATA_CORRECTION.VCI.VWC_CURRENT_CUSTOMER_BULLET_1)}
            </li>
            {!isCanada && <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
              {i18n.t(rk.DATA_CORRECTION.VCI.VWC_CURRENT_CUSTOMER_BULLET_2)}
            </li>}
            {isCanada && <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
              {i18n.t(rk.DATA_CORRECTION.VCI.VWC_CURRENT_CUSTOMER_BULLET_2_CANADA_1)}
              <a
                className="a-link-cta-bullet"
                href={i18n.t(rk.DATA_CORRECTION.VCI.VWC_CURRENT_CUSTOMER_BULLET_2_CANADA_VFLINK)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n.t(rk.DATA_CORRECTION.VCI.VWC_CURRENT_CUSTOMER_BULLET_2_CANADA_VF)}
              </a>
              {i18n.t(rk.DATA_CORRECTION.VCI.VWC_CURRENT_CUSTOMER_BULLET_2_CANADA_2)}
            </li>}
            <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
              {i18n.t(rk.DATA_CORRECTION.VCI.VWC_CURRENT_CUSTOMER_BULLET_3)}
            </li>
            {isCanada && <div>
              <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
                {i18n.t(rk.DATA_CORRECTION.VCI.VWC_CURRENT_CUSTOMER_BULLET_4)}
              </li> 
            </div>}
            {isCanada && <div>
              <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
                {i18n.t(rk.DATA_CORRECTION.VCI.VWC_CURRENT_CUSTOMER_BULLET_5)}
              </li> 
            </div>}
          </ul>
        </div>
      </div>
      <div className="welcome-note u-mt">
        <div className="u-mb-small">
          {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_WITH_NO_ACCOUNT)}
        </div>
        <p className="u-mb-none u-font-size-fs0">{i18n.t(rk.DATA_CORRECTION.VCI.VWCREDIT_CONTACT)}</p>
        <p className="u-mb-none u-font-size-fs0">{i18n.t(rk.DATA_CORRECTION.VCI.AFS_CONTACT)}</p>
        {!isCanada && <p className="u-mb-none u-font-size-fs0">{i18n.t(rk.DATA_CORRECTION.VCI.DFS_CONTACT)}</p>}
      </div>
      <div className="u-mb">
        <div className="center-div u-mb-small">
          <a className="request-form-link" href={formLink} download="RighttoCorrectForm">
            <button
              id="download-request-btn"
              className="c-btn u-mv-none"
              disabled={false}
            >
              <span className="c-btn__text">
                {i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_OR_REP_CTA)}
              </span>
            </button>
          </a>
        </div>
      </div>
      <div className="u-mt u-mb-large">
        <p className="u-font-size-fs0">
          {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_TEXT_1)}
        </p>
        <span>
          <p className="u-mb-none intructions-title u-font-size-fs0">
            {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_TEXT_2)}
          </p>
          <p className="u-mb-none u-font-size-fs0">
            {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_TEXT_3)}
          </p>
          <p className="u-mb-none u-font-size-fs0">
            {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_TEXT_4)}
          </p>
        </span>
      </div>
    </div>
  );
};

VCIConsumer.propTypes = {
  language: PropTypes.string,
  isWithdraw: PropTypes.bool,
  isCanada: PropTypes.bool,
}

export default VCIConsumer;
